const DeprecComparisonForm = () => {
  return <></>
}

export default DeprecComparisonForm
